import _ from 'lodash';
import { setDisplayName } from 'recompose';

const renderChildren = children => (_.isFunction(children) ? children() : children);
export default setDisplayName('FlaggedRender')(({ shouldRender, children }) =>
  (shouldRender ? renderChildren(children) : null));
